import { FC } from 'react';

interface Props {
  Component: FC;
}

export const PublicRoute: FC<Props> = ({ Component }) => <Component />;
